import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
// import { Link } from "@mui/material";
import { Link, useParams } from "react-router-dom";



var Model = require("../information/model");

const HighRisk = () => {
    const id = useSelector((state) => state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
    let dataTable = useSelector(
        (state) => state?.customer?.companyList?.data
    );
    return (
        <div className="container-fluid">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                       <h1 className="welcome-text">Dashboard</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/vendor">Risks /</Link> vulnerability
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
           
        </div>
    );
};

export default HighRisk;
